"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fundingChartDataLength = exports.blockInterval = void 0;
const enum_1 = require("./enum");
exports.blockInterval = {
    BLAST: 2,
    BASE: 2,
};
exports.fundingChartDataLength = new Map([
    [enum_1.FundingChartInterval.HOUR, 72],
    [enum_1.FundingChartInterval.EIGHT_HOUR, 42],
]);
